export const SOURCE_SCREENS = Object.freeze({
  ACCOUNT_SETTING: 'js_account_setting',
  APPLICATION_TRACKING: 'js_application_tracking',
  APPLY_SUCCESS: 'js_apply_success',
  COMPANY_PROFILE: 'js_company_profile',
  COMMUNITY_FEED: 'js_community_feed',
  COMMUNITY_POST_DETAIL: 'js_community_post_detail',
  CREATE_CV: 'create_cv',
  CV_BUILDER: 'cv_builder',
  CV_REVIEW_LANDING_PAGE: 'cv_review_landing_page',
  HOMEPAGE: 'js_homepage',
  // Distinct downstream analytics contracts; migrate consumers before merging.
  JOB_DETAIL: 'js_job_detail',
  JOB_DETAILS: 'js_job_details',
  JOB_PREVIEW: 'js_job_preview',
  MY_PROFILE: 'js_my_profile',
  OPPORTUNITY_DETAILS: 'js_opportunity_details',
  PROFILE: 'profile',
  REVIEW_CV: 'review_cv',
  SAVED_JOB: 'js_saved_job',
  SEARCH_RESULT: 'js_search_result',
} as const);

export type SourceScreen = (typeof SOURCE_SCREENS)[keyof typeof SOURCE_SCREENS];

export function getTrackingScreen(pathname: string): string {
  switch (true) {
    case pathname === '/':
      return SOURCE_SCREENS.HOMEPAGE;
    case pathname === '/cong-ty':
      return SOURCE_SCREENS.COMPANY_PROFILE;

    case pathname === '/thao-luan':
      return SOURCE_SCREENS.COMMUNITY_FEED;

    case pathname.startsWith('/thao-luan/'):
      return SOURCE_SCREENS.COMMUNITY_POST_DETAIL;

    case pathname === '/viec-lam':
      return SOURCE_SCREENS.SEARCH_RESULT;

    case pathname.startsWith('/viec-lam/'):
      return SOURCE_SCREENS.JOB_DETAILS;

    case pathname.startsWith('/quan-ly-trang-thai-ung-tuyen'):
      return SOURCE_SCREENS.APPLICATION_TRACKING;

    case pathname.startsWith('/viec-da-luu'):
      return SOURCE_SCREENS.SAVED_JOB;

    case pathname.startsWith('/ho-so'):
      return SOURCE_SCREENS.MY_PROFILE;

    case pathname.startsWith('/cai-dat-tai-khoan'):
      return SOURCE_SCREENS.ACCOUNT_SETTING;

    case pathname === '/tao-cv':
      return SOURCE_SCREENS.CV_REVIEW_LANDING_PAGE;

    case pathname.startsWith('/tao-cv/create'):
      return SOURCE_SCREENS.CREATE_CV;

    case pathname.startsWith('/tao-cv/edit'):
      return SOURCE_SCREENS.REVIEW_CV;

    case pathname.startsWith('/tao-cv'):
      return SOURCE_SCREENS.CV_BUILDER;

    default:
      return pathname.split('/').filter(Boolean).join('_').replaceAll('-', '_');
  }
}

// Backward-compatible names; values still come from the single shared registry.
export const CV_REVIEW_LANDING_PAGE_SOURCE_SCREEN =
  SOURCE_SCREENS.CV_REVIEW_LANDING_PAGE;
export const CREATOR_CV_SOURCE_SCREENING = SOURCE_SCREENS.CREATE_CV;
export const REVIEWER_CV_SOURCE_SCREENING = SOURCE_SCREENS.REVIEW_CV;
export const CV_BUILDER_SOURCE_SCREENING = SOURCE_SCREENS.CV_BUILDER;

export function getAuthModalSourceScreen(
  type?: 'create' | 'edit'
): SourceScreen | undefined {
  if (type === 'create') return CREATOR_CV_SOURCE_SCREENING;
  if (type === 'edit') return REVIEWER_CV_SOURCE_SCREENING;

  return undefined;
}
